import { forwardRef, type ButtonHTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

type Variant = 'default' | 'primary-active' | 'info-active' | 'disable'

export type ButtonPillProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant
}

const variantClasses: Record<Variant, string> = {
  default: 'bg-lc-gray-100 text-lc-gray-600',
  'primary-active': 'bg-lc-orange-900 text-white',
  'info-active': 'bg-lc-lightblue-900 text-white',
  disable: 'bg-lc-gray-400 text-white pointer-events-none',
}

export const ButtonPill = forwardRef<HTMLButtonElement, ButtonPillProps>(
  function ButtonPill(
    { variant = 'default', className, type = 'button', disabled, children, ...rest },
    ref,
  ) {
    const isDisabled = disabled || variant === 'disable'
    return (
      <button
        ref={ref}
        type={type}
        disabled={isDisabled}
        className={cn(
          'inline-flex items-center justify-center rounded-lc-pill',
          'px-5 py-[6px]',
          'font-medium text-[18px] leading-[1.5] tracking-[-0.6px]',
          'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-lc-lightblue-900',
          variantClasses[variant],
          className,
        )}
        {...rest}
      >
        {children}
      </button>
    )
  },
)
